import { useId } from 'react';
import communityLight from '../presentation/common/scenes/community-light.webp';
import communityDark from '../presentation/common/scenes/community-dark.webp';
import fantasyLight from '../presentation/common/scenes/fantasy-light.webp';
import fantasyDark from '../presentation/common/scenes/fantasy-dark.webp';
import recyclingBin from '../presentation/common/scenes/recycling-bin-grounded.webp';
import { landingCourtyardLayout } from './landingCourtyardLayout';

const scenes = { community: { light: communityLight, dark: communityDark }, fantasy: { light: fantasyLight, dark: fantasyDark } };

export default function LandingCourtyardArtwork({ mode, theme, bounds, thumbnail = false }) {
  const shadowId = `cleanup-shadow-${useId().replace(/[^a-zA-Z0-9_-]/g, '')}`;
  const width = bounds.right - bounds.left;
  const height = bounds.bottom - bounds.top;
  // Cover the full viewport, including the area beyond the interaction stage.
  // The same bounds are frozen at shutter time so the photo keeps its crop.
  const { art, bin, mouth, ground } = landingCourtyardLayout(bounds, mode);
  return <svg className="cleanup-courtyard" viewBox={thumbnail ? `${bounds.left} ${bounds.top} ${width} ${height}` : '0 0 600 460'} aria-hidden="true" focusable="false" data-world={mode} data-theme={theme}>
    <defs>
      <filter id={`${shadowId}-cast`} x="-40%" y="-100%" width="180%" height="300%"><feGaussianBlur stdDeviation={bin.height * .025} /></filter>
      <filter id={`${shadowId}-contact`} x="-20%" y="-100%" width="140%" height="300%"><feGaussianBlur stdDeviation={bin.height * .009} /></filter>
    </defs>
    <image className="cleanup-courtyard-background" href={(scenes[mode] || scenes.community)[theme === 'dark' ? 'dark' : 'light']} {...art} />
    <g>
      <g className="cleanup-bin-shadow" fill="#17221c" style={{ mixBlendMode: 'multiply' }}>
        <ellipse cx={mouth.x + bin.width * .32} cy={ground + bin.height * .015} rx={bin.width * .86} ry={bin.height * .047} opacity={theme === 'dark' ? .25 : .19} filter={`url(#${shadowId}-cast)`} />
        <ellipse cx={mouth.x} cy={ground - bin.height * .014} rx={bin.width * .49} ry={bin.height * .026} opacity=".62" filter={`url(#${shadowId}-contact)`} />
      </g>
      <g className={thumbnail ? undefined : 'cleanup-bin-target'}>
        <svg className="cleanup-bin" {...bin} viewBox="0 0 275 456" overflow="visible">
          <image href={recyclingBin} width="275" height="456" />
        </svg>
      </g>
    </g>
  </svg>;
}
